import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { SignUpForm } from './SignUpForm'; // Adjust path
import { Box, Typography, Grid, CircularProgress, Alert } from '@mui/material';
import { useStripeSession } from '../../../hooks/useStripe';

const subscriptionTiers = {
    basic: { name: 'basic', price: '24.99' },
    pro: { name: 'pro', price: '49.99' },
    default: { name: 'Subscription', price: '0.00' }
};

export default function SignUpPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  const sessionId = searchParams.get('session_id');

  const { isLoading, email, tier, error } = useStripeSession(sessionId);
  const subscription = subscriptionTiers[tier] || subscriptionTiers.default;

  const authStrings = {
      signUpHeader: "Complete your account",
      signUpSubtitle: "You've successfully subscribed! Just create a password to finish.",
      emailLabel: "Email",
      passwordLabel: "Password",
      confirmPasswordLabel: "Confirm password",
      passwordsMustMatch: "Passwords must match.",
      switchToSignIn: "Sign in instead",
      submitButton: "Create account"
  };

  if (isLoading) {
    return (
      <Grid container component="main" sx={{ height: '100vh', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f7fafc' }}>
        <CircularProgress />
        <Typography variant="h6" sx={{ ml: 2, color: '#4a5568' }}>Verifying your subscription...</Typography>
      </Grid>
    );
  }

  return (
    <Grid container component="main" sx={{ height: '100vh' }}>
      {/* Left Column (Branding Panel) */}
      <Grid item xs={12} sm={4} md={5} sx={{ 
          backgroundColor: '#00897b', 
          color: 'white', 
          display: { xs: 'none', sm: 'flex' }, 
          flexDirection: 'column', 
          p: 4, 
          justifyContent: 'space-between' 
      }}>
        <Box
          component="img"
          src="ct_logo.png"
          alt="CandidateTools logo"
          sx={{ width: '100%', maxWidth: '250px', height: 'auto', mb: 3 }}
          onError={(e) => { 
            e.target.onerror = null; 
            e.target.src='https://placehold.co/250x60/00897b/FFFFFF?text=CandidateTools&font=roboto'; 
          }}
        />  
        <Box>  
            <Typography variant="h5" component="h1" sx={{ mb: 1 }}>
              Subscribed to {subscription.name}
            </Typography>
            <Typography variant="h3" component="p" sx={{ fontWeight: 'bold' }}>
                ${subscription.price}
                <Typography component="span" sx={{ fontSize: '1rem', fontWeight: 'normal', ml: 1 }}>
                  per month
                </Typography>
            </Typography>
        </Box>
        <Box />
      </Grid>
      
      {/* Right Column (Form Panel) */}
      <Grid item xs={12} sm={8} md={7} component={Box} sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center',
          backgroundColor: '#fff',
          p: 2
      }}>
        <SignUpForm 
          strings={authStrings}
          defaultEmail={email} 
          emailDisabled={true} // Pass prop to disable the email field
        />
      </Grid>
    </Grid>
  );
}